import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';


const Footer = () => {
  const currentYear = new Date().getFullYear();


  const footerLinks = {
    product: [
      { name: 'Features', href: '/features' },
      { name: 'Roadmap', href: '/roadmap' }
    ],
    company: [
      { name: 'About', href: '/about' }
    ],
    support: [
      { name: 'FAQ', href: '/faq' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' }
    ]
  };

  const socialLinks = [
    { name: 'X', href: 'https://x.com/RoccoScalps', icon: null },
    { name: 'Email', href: 'mailto:support@claraai.net', icon: Mail }
  ];

  return (
    <footer className="bg-clara-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <img 
                  src="/assets/claraailogo4.png" 
                  alt="ClaraAI Logo" 
                  className="w-10 h-10 object-contain"
                />
                <span className="text-xl font-bold">ClaraAI</span>
              </div>
              <p className="text-clara-gray-300 mb-6 max-w-md">
                Revolutionary macOS productivity app with AI-powered Vision Frame. 
                Transform how you work with intelligent insights and automation.
              </p>
              
              {/* Social Links */}
              <div className="flex space-x-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-clara-gray-800 rounded-lg flex items-center justify-center text-clara-gray-300 hover:text-clara-blue-400 hover:bg-clara-gray-700 transition-all duration-200"
                  >
                    {social.icon ? (
                      <social.icon className="w-5 h-5" />
                    ) : (
                      <span className="text-xl font-bold">𝕏</span>
                    )}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div
              key={category}
            >
              <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
                {category}
              </h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    {link.href.startsWith('/') ? (
                      <Link
                        to={link.href}
                        className="text-clara-gray-300 hover:text-clara-blue-400 transition-colors duration-200 text-sm"
                      >
                        {link.name}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-clara-gray-300 hover:text-clara-blue-400 transition-colors duration-200 text-sm"
                      >
                        {link.name}
                      </a>
                    )}
                  </li>
                ))}
                {category === 'support' && (
                  <li>
                    <a
                      href="mailto:support@claraai.net?subject=Contact Support"
                      className="text-clara-gray-300 hover:text-clara-blue-400 transition-colors duration-200 text-sm"
                    >
                      Contact
                    </a>
                  </li>
                )}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="border-t border-clara-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-2 text-clara-gray-400 text-sm">
              <span>© {currentYear} ClaraAI. All rights reserved.</span>
            </div>
            
            <div className="flex items-center space-x-6 text-sm">
              <Link to="/privacy" className="text-clara-gray-400 hover:text-clara-blue-400 transition-colors duration-200">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-clara-gray-400 hover:text-clara-blue-400 transition-colors duration-200">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
      

    </footer>
  );
};

export default Footer; 